import RadioGroup from './radio-group.element.js';

export default RadioGroup;

RadioGroup.define('wje-radio-group', RadioGroup);
